import { render, staticRenderFns } from "./AddMediaIcon.vue?vue&type=template&id=1d064148&"
import script from "./AddMediaIcon.vue?vue&type=script&lang=js&"
export * from "./AddMediaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports